// Mock data for HMI Dashboard V2
// Stats with value '--' indicate: needs real data source

export const STAT_CARDS = [
  { id: 'activeBids', label: 'ACTIVE BIDS', value: '12', sub: '3 due this week', meter: { width: 25, fill: 'warn' } },
  { id: 'openProjects', label: 'OPEN PROJECTS', value: '34', sub: '8 in progress \u00b7 26 scheduled' },
  { id: 'pipelineValue', label: 'PIPELINE VALUE', value: '$2.4M', sub: 'PipeDrive \u00b7 47 leads', meter: { width: 62, fill: 'brand' } },
  { id: 'unclaimedWork', label: 'UNCLAIMED WORK', value: '8', sub: '3 urgent \u00b7 needs assignment', numClass: 'warn' },
  { id: 'issues', label: 'ISSUES', value: '5', sub: '2 escalated \u00b7 1 new today', numClass: 'warn', meter: { width: 40, fill: 'risk' } },
]

export const CORE_TOOLS = [
  {
    id: 'bids', title: 'Bids',
    desc: 'Bid assembly, line items, cost estimation, and output generation.',
    stripeColor: 'var(--brand)', iconBg: 'var(--brand-tint)', iconColor: 'var(--brand-deep)',
    icon: 'document',
    pill: null,
    stats: [{ value: '--', label: 'active' }, { value: '--', label: 'draft' }, { value: '--', label: 'total' }],
    href: '/bid-estimation',
  },
  {
    id: 'projects', title: 'Projects',
    desc: 'Active project management synced from Aspire. Track status, crews, and schedules.',
    stripeColor: 'oklch(0.56 0.08 230)', iconBg: 'var(--info-tint)', iconColor: 'var(--info)',
    icon: 'screen',
    pill: null,
    stats: [{ value: '--', label: 'active' }, { value: '--', label: 'in progress' }],
    href: '/projects',
  },
  {
    id: 'leads', title: 'Leads',
    desc: 'Lead pipeline — track proposals, follow-ups, and conversions.',
    stripeColor: 'var(--accent)', iconBg: 'var(--accent-tint)', iconColor: 'var(--accent-deep)',
    icon: 'people',
    pill: null,
    stats: [{ value: '--', label: 'total' }, { value: '--', label: 'new' }, { value: '--', label: 'conv.' }],
    href: '/leads',
  },
]

export const OPS_DASHBOARDS = [
  {
    id: 'herbicide', title: 'Herbicide',
    desc: 'Application tracking, chemical inventory, compliance logs, and crew schedules.',
    stripeColor: 'oklch(0.45 0.12 305)', iconBg: 'oklch(0.94 0.04 305)', iconColor: 'oklch(0.45 0.12 305)',
    icon: 'shield',
    pill: null,
    stats: [{ value: '--', label: 'overdue' }, { value: '--', label: 'need completion' }, { value: '--', label: 'done today' }],
    href: '/herbicide-schedule-v4',
  },
  {
    id: 'irrigation', title: 'Irrigation',
    desc: 'System health, controller status, repair tickets, and water usage metrics.',
    stripeColor: 'oklch(0.42 0.10 230)', iconBg: 'oklch(0.94 0.04 230)', iconColor: 'oklch(0.42 0.10 230)',
    icon: 'droplet',
    pill: null,
    stats: [{ value: '--', label: 'last inspection' }, { value: '--', label: 'require one' }],
    href: '/hmiirrigationdashboard',
  },
  {
    id: 'equipment', title: 'Equipment',
    desc: 'Fleet overview, vehicle registrations, GPS tracking, and asset management.',
    stripeColor: 'oklch(0.42 0.08 195)', iconBg: 'oklch(0.94 0.04 195)', iconColor: 'oklch(0.42 0.08 195)',
    icon: 'truck',
    stats: [{ value: '--', label: 'in fleet' }, { value: '--', label: 'expired reg' }, { value: '--', label: 'mtc overdue' }],
    href: '/shop/fleet-overview',
  },
  {
    id: 'shop', title: 'Shop',
    desc: 'Repair requests, fault codes, fitment tracking, and shop inventory.',
    stripeColor: 'oklch(0.48 0.06 45)', iconBg: 'oklch(0.94 0.02 45)', iconColor: 'oklch(0.48 0.06 45)',
    icon: 'wrench',
    stats: [{ value: '--', label: 'open repairs' }, { value: '--', label: 'requests' }],
    href: '/shop',
  },
  {
    id: 'properties', title: 'Properties',
    desc: 'Complete property directory — service history, profit margins, and map visualization.',
    stripeColor: 'var(--brand)', iconBg: 'var(--brand-tint)', iconColor: 'var(--brand-deep)',
    icon: 'screen',
    stats: [{ value: '--', label: 'properties' }, { value: '--', label: 'active contracts' }],
    href: '/hmi/properties',
  },
  {
    id: 'disposal', title: 'Disposal / Waste',
    desc: 'Disposal facilities, roll-off vendor rates, and haul-off pricing.',
    stripeColor: 'oklch(0.50 0.14 25)', iconBg: 'oklch(0.94 0.04 25)', iconColor: 'oklch(0.50 0.14 25)',
    icon: 'trash',
    stats: [{ value: '--', label: 'facilities' }, { value: '--', label: 'vendor rates' }],
    href: '/bid-estimation/rates',
  },
  {
    id: 'aggregate', title: 'Aggregate',
    desc: 'Material profiles, supplier offerings, pricing, and availability.',
    stripeColor: 'oklch(0.42 0.04 60)', iconBg: 'oklch(0.93 0.012 60)', iconColor: 'oklch(0.42 0.04 60)',
    icon: 'layers',
    stats: [{ value: '--', label: 'materials' }, { value: '--', label: 'offerings' }],
    href: '/aggregate-dashboard',
  },
]

export const ATTENTION_ITEMS = []

export const ACTIVITY_ITEMS = []

export const BID_DEADLINES = []

export const QUICK_LINKS = [
  { label: 'Property Overview', dotColor: 'var(--brand)', href: '/hmi/properties' },
  { label: 'Issues', dotColor: 'var(--risk)', href: '#' },
  { label: 'Estimating Configs', dotColor: 'oklch(0.45 0.12 305)', href: '/bid-estimation/rates' },
  { label: 'Routing', dotColor: 'oklch(0.42 0.08 195)', href: '/routing' },
  { label: 'Subcontractors', dotColor: 'oklch(0.45 0.08 270)', href: '/subcontractors' },
  { label: 'Sub Invoices', dotColor: 'oklch(0.50 0.10 55)', href: '/hmi/subcontractor-invoices' },
  { label: 'Fleet Tracking', dotColor: 'var(--brand)', href: '/admin/geotab-dashboard' },
  { label: 'Crew & Fleet', dotColor: 'var(--brand)', href: '/crew-dashboard' },
  { label: 'Dead Plants', dotColor: 'oklch(0.50 0.14 25)', href: '/admin-dead-plants-dashboard' },
  { label: 'Vendors', dotColor: 'oklch(0.50 0.10 55)', href: '/vendors' },
  { label: 'Vendor Catalogs', dotColor: 'oklch(0.50 0.10 55)', href: '/vendor-catalogs' },
  { label: 'Knowledge Base', dotColor: 'oklch(0.42 0.08 195)', href: '/knowledge-base' },
  { label: 'Customer Feedback', dotColor: 'var(--ok)', href: '/complaints' },
  { label: 'Reports', dotColor: 'var(--info)', href: '/reports' },
]

export const CONNECTED_SYSTEMS = [
  {
    id: 'aspire', name: 'Aspire CRM',
    desc: 'Primary CRM \u00b7 Projects, work orders, crews, scheduling, and invoicing',
    logoBg: 'oklch(0.94 0.04 230)', logoColor: 'oklch(0.42 0.10 230)', logoLetter: 'A',
    stats: [{ value: '34', label: 'projects' }, { value: '86', label: 'work orders' }, { value: '2m ago', label: 'Synced' }],
    buttonLabel: 'Open Aspire',
    href: '#',
  },
  {
    id: 'pipedrive', name: 'PipeDrive',
    desc: 'Lead management \u00b7 Pipeline, proposals, contacts, and deal tracking',
    logoBg: 'oklch(0.94 0.04 155)', logoColor: 'var(--brand-deep)', logoLetter: 'P',
    stats: [{ value: '47', label: 'leads' }, { value: '$2.4M', label: 'pipeline' }, { value: '5m ago', label: 'Synced' }],
    buttonLabel: 'Open PipeDrive',
    href: '#',
  },
]

export const UNCLAIMED_ITEMS = []

export const CONTACTS = {
  customers: [],
  internal: [],
}

export const SOURCES = [
  'Phone call', 'Voicemail (VoIP)', 'SMS (VoIP)', 'Email',
  'Field observation', 'Aspire work order', 'Customer portal', 'Walk-in',
]

export const SERVICE_TYPES = [
  { label: 'Irrigation', dotColor: 'oklch(0.42 0.10 230)' },
  { label: 'Herbicide', dotColor: 'oklch(0.45 0.12 305)' },
  { label: 'Hardscape', dotColor: 'oklch(0.42 0.04 60)' },
  { label: 'Planting', dotColor: 'var(--brand-deep)' },
  { label: 'Disposal', dotColor: 'oklch(0.50 0.14 25)' },
  { label: 'General', dotColor: 'var(--ink-3)' },
]
